/* Back-in-stock request widget.
   - Toggle button reveals an email form (native Shopify customer form that tags
     the contact with back-in-stock + product handle + variant id).
   - Visibility and the variant tag track variant changes via Dawn's pubsub. */
(function () {
  function init() {
    var widgets = document.querySelectorAll('.bis-widget');
    if (!widgets.length) return;

    widgets.forEach(function (widget) {
      if (widget.dataset.bisInit === 'true') return;
      widget.dataset.bisInit = 'true';

      var toggle = widget.querySelector('.bis-widget__toggle');
      var formWrap = widget.querySelector('.bis-widget__form');
      var tagsInput = widget.querySelector('[data-bis-tags]');

      if (toggle && formWrap) {
        toggle.addEventListener('click', function () {
          var open = formWrap.classList.toggle('hidden');
          toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (!open) {
            var email = formWrap.querySelector('input[type="email"]');
            if (email) email.focus();
          }
        });
      }

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          if (!event.data || event.data.sectionId !== widget.dataset.bisSection) return;
          var variant = event.data.variant;
          var available = !!(variant && variant.available);
          widget.classList.toggle('hidden', available);
          if (variant && tagsInput) {
            tagsInput.value = tagsInput.value.replace(/bis-variant:\d+/, 'bis-variant:' + variant.id);
          }
        });
      }
    });

    // If the customer form posted successfully, reopen the widget to show the message.
    if (window.location.search.indexOf('customer_posted=true') !== -1) {
      var w = document.querySelector('.bis-widget');
      if (w) {
        var fw = w.querySelector('.bis-widget__form');
        if (fw) fw.classList.remove('hidden');
        w.scrollIntoView({ block: 'center' });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
